import Highlight from "./highlight";
import {ResourceTypeEnum} from "../../base/training-literals";

class Boundary extends Highlight {

    constructor(props = {}) {
        super(props);
        this.actionType = ResourceTypeEnum.BOUNDARY;
    }

    get(props = {}) {
        return props;
    }
}

export default Boundary;
